export const setNewError = (value=null) => {
    return { type: "SET_NEW_ERROR", payload: value };
}